import React, { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  Stack,
  Tab,
  Tabs,
  Alert,
  Button,
} from "@mui/material";
import { languageOptions } from "../../../languages";
import lovStore from "../../../stores/LovStore";
import { Lov } from "../../../stores/LovStore/LovStore";
import "./DictionaryManagement.scss";

const DictionaryManagement = () => {
  const [selectedLanguage, setSelectedLanguage] = useState("tr");
  const [textareaValue, setTextareaValue] = useState("");
  const [lov, setLov] = useState<Lov | null>();
  const [loading, setLoading] = useState(false);
  const [jsonError, setJsonError] = useState<string | null>(null);
  const hasChanges = JSON.stringify(lov?.value, null, 2) !== textareaValue;

  useEffect(() => {
    setLoading(true);
    lovStore
      .fetchLovByCode(
        `lang-${selectedLanguage}-all`,
        `lang-${selectedLanguage}`,
        false
      )
      .then((data) => {
        if (data?.value && Object.keys(data?.value || {}).length > 0) {
          setTextareaValue(JSON.stringify(data.value, null, 2));
        } else {
          setTextareaValue("{}");
        }
        setLov(data);
        setJsonError(null);
      })
      .finally(() =>
        setTimeout(() => {
          setLoading(false);
        }, 300)
      );
  }, [selectedLanguage]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setSelectedLanguage(newValue);
  };

  const handleTextareaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    setTextareaValue(value);
    try {
      JSON.parse(value);
      setJsonError(null);
    } catch (err: any) {
      setJsonError("FORMAT HATASI: " + err.message);
    }
  };

  const handleSubmit = () => {
    if (!lov) {
      return;
    }

    const data = { ...lov, value: JSON.parse(textareaValue) };

    setLoading(true);
    lovStore.updateLov(lov.id, data).finally(() => {
      setLov(data);
      setLoading(false);
    });
  };

  return (
    <div className="container admin-container dictionary-management">
      {loading ? (
        <Stack
          direction={"row"}
          justifyContent={"center"}
          alignItems={"center"}
          className={"pt pb"}
        >
          <CircularProgress />
        </Stack>
      ) : (
        <>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={selectedLanguage}
              onChange={handleTabChange}
              aria-label="language tabs"
            >
              {languageOptions.map((lang) => (
                <Tab key={lang.key} label={lang.key} value={lang.key} />
              ))}
            </Tabs>
          </Box>
          <Box sx={{ mt: 2 }}>
            {jsonError && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {jsonError}
              </Alert>
            )}
            <textarea
              rows={40}
              style={{ width: "100%" }}
              value={textareaValue}
              onChange={handleTextareaChange}
            />
            <div className="mt">
              <Button
                fullWidth
                variant="outlined"
                disabled={
                  !textareaValue || !hasChanges || !!jsonError || loading
                }
                onClick={handleSubmit}
              >
                Kaydet
              </Button>
            </div>
          </Box>
        </>
      )}
    </div>
  );
};

export default DictionaryManagement;
